import React, { useEffect, useState } from "react";
import axios from "axios";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.js";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import styles from 'views/component/Styles.js';

import GridItem from "components/Grid/GridItem";
import ToggleInput from "views/component/ToggleInput";
import GridContainer from "components/Grid/GridContainer";
import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select } from "@material-ui/core";
import { Check } from "@material-ui/icons";

const useStyles = makeStyles(styles);
const useModalStyles = makeStyles(modalStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ReqPopup(props) {
    const { factory, modal, onClose, onSave } = props;
    const tempTime = new Date();
    const requestId = 'REQ' + new Date(tempTime.getTime() - tempTime.getTimezoneOffset() * 60000).toISOString().replace(/\D/g, '');
    const [editData, setEditData] = useState({
        "optimizerType": 0, "optimizerTime": 200, "balancingFlag": true, "settingFlag": true, "movingDelayFlag": true
    });

    const classes = { ...useStyles(), ...useModalStyles() };
    const setModal = function (modal) {
        onClose(modal);
    }
    useEffect(() => {
    }, []);
    const handleValueChange = function (name, value) {
        let temp = { ...editData };
        temp[name] = value;
        setEditData(temp);
    }
    const handleSave = function () {
        const message = JSON.stringify({...editData, ...factory, requestId : requestId});
        let temp = { requestId: requestId, ...factory, insert: true, 
            requestVal: message };
        axios.post('aps/listedit/requestInfo', [temp]).then(response => {
            if (onSave) {
                onSave(temp);
            }
        });
        axios.post('aps/publish', { 'message': message });
        if (onSave) onSave();
        setModal(false);
    }
    return (
        <Dialog classes={{ root: classes.center, paper: classes.modal }}
            open={modal} transition={Transition} keepMounted fullWidth
            onClose={() => setModal(false)}
            aria-labelledby="modal-slide-title" aria-describedby="modal-slide-description" >
            <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
                <Button justIcon className={classes.modalCloseButton} key="close"
                    aria-label="Close" color="transparent" onClick={() => setModal(false)}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>신규 요청</h4>
            </DialogTitle>
            <DialogContent id="modal-slide-description" className={classes.modalBody}>
                <GridContainer>
                    <GridItem key='requestId' md>
                        <ToggleInput label='요청 ID' name='requestId' value={requestId} />
                    </GridItem>
                    <GridItem key='optimizerType' md>
                        <FormControl fullWidth className={classes.selectFormControlInfo}>
                            <InputLabel className={classes.selectLabel}>
                                최적화 타입
                            </InputLabel>
                            <Select MenuProps={{ className: classes.selectMenu }} classes={{ select: classes.select }}
                                value={editData['optimizerType']} onChange={e => { handleValueChange('optimizerType', e.target.value) }} >
                                {['단순배치', 'Rule', 'Optimizer'].map((item, index) => {
                                    return <MenuItem value={index} key={index}
                                        classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedInfo }}>
                                        {item}
                                    </MenuItem>;
                                })}
                            </Select>
                        </FormControl>
                    </GridItem>
                    <GridItem key='optimizerTime' md>
                        <ToggleInput edit label='최적화 시간' name='optimizerTime' type='number'
                            value={editData['optimizerTime']} onChange={handleValueChange} />
                    </GridItem>
                    <GridItem key='balancingFlag' md>
                        <div className={classes.checkboxAndRadio}>
                            <FormControlLabel key='balancingFlag'
                                control={
                                    <Checkbox checked={editData['balancingFlag']}
                                        onClick={() => handleValueChange('balancingFlag', !editData['balancingFlag'])}
                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                        icon={<Check className={classes.uncheckedIcon} />}
                                        classes={{ checked: classes.checked, root: classes.checkRoot }}
                                    />
                                }
                                classes={{ label: classes.label, root: classes.labelRoot }}
                                label={'밸런싱 반영'}
                            />
                        </div>
                    </GridItem>
                    <GridItem key='settingFlag' md>
                        <div className={classes.checkboxAndRadio}>
                            <FormControlLabel key='settingFlag'
                                control={
                                    <Checkbox checked={editData['settingFlag']}
                                        onClick={() => handleValueChange('settingFlag', !editData['settingFlag'])}
                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                        icon={<Check className={classes.uncheckedIcon} />}
                                        classes={{ checked: classes.checked, root: classes.checkRoot }}
                                    />
                                }
                                classes={{ label: classes.label, root: classes.labelRoot }}
                                label={'셋팅 반영'}
                            />
                        </div>
                    </GridItem>
                    <GridItem key='movingDelayFlag' md>
                        <div className={classes.checkboxAndRadio}>
                            <FormControlLabel key='movingDelayFlag'
                                control={
                                    <Checkbox checked={editData['movingDelayFlag']}
                                        onClick={() => handleValueChange('movingDelayFlag', !editData['movingDelayFlag'])}
                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                        icon={<Check className={classes.uncheckedIcon} />}
                                        classes={{ checked: classes.checked, root: classes.checkRoot }}
                                    />
                                }
                                classes={{ label: classes.label, root: classes.labelRoot }}
                                label={'공정간 이동시간 반영'}
                            />
                        </div>
                    </GridItem>
                    <GridItem key='buttons' md>
                        <Button color="success" className={classes.right} size="sm" onClick={handleSave}>저장</Button>
                        <Button color="danger" className={classes.right} size="sm"
                            onClick={e => { if (onClose) onClose(); }}>취소</Button>
                    </GridItem>
                </GridContainer>
            </DialogContent>
        </Dialog>
    );
}